<template lang="pug">
.video-intern
    video.vjs-default-skin.vjs-big-play-centered(
        v-if="thumbnail"
        ref="player"
        class="video-js"
        loop="true"
        :poster='thumbnail.src'
        controls
    )
        source(:src="src", :type="mime")
    video.vjs-default-skin.vjs-big-play-centered(
        v-else
        ref="player"
        class="video-js"
        loop="true"
        controls
    )
        source(:src="src", :type="mime")
</template>
<script>
//import Components
import { mapGetters } from 'vuex';
import { get, trim } from '@/helpers';

import videojs from 'video.js';
import 'videojs-http-source-selector';
import 'videojs-contrib-quality-levels';
import 'video.js/dist/video-js.min.css';

export default {
    name: 'Intern',
    props: {
        video: {
            type: Object,
            required: true
        },
        videoProperties: {
            type: Object
        },
        videoThumb: {
            type: Object
        }
    },
    data() {
        return {
            player: null
        };
    },
    watch: {
        src(fresh, old) {
            if (old && fresh !== old && this.player) {
                this.player.pause();
                this.player.src([
                    {
                        type: this.mime,
                        src: this.src
                    }
                ]);
                // this.initialise()
                this.player.load();
                this.player.play();
            }
        }
    },
    computed: {
        isHls() {
            return !!get(this.video.video, 'hls');
        },

        mime() {
            if (this.isHls) {
                return this.video.video.hls.mime;
            } else {
                return this.video.video.source.mime;
            }
        },

        thumbnail() {
            const image = get(this.videoThumb, 'images.0');
            if (!image) return false;

            const storageRoute = trim(
                `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
                '/'
            );

            let format = '';
            if (this.webpSupport) format = '&format=webp';
            
            let fit = get(image, 'pivot.fit') || 'crop=focalpoint&x=.5&y=.5&z=1';

            return {
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}${format}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`
            };
        },

        src() {
            let src;
            if (this.video.video) {
                if (this.isHls) {
                    src = get(this.video.video, 'hls.url');
                } else {
                    src = get(this.video.video, 'source.url');
                }
            }
            // this.activeProductMedia.data.hls
            return src;
        },
        ...mapGetters({
            webpSupport: 'webpSupport'
        })
    },
    methods: {
        initialise() {
            const options = {
                autoplay: this.videoProperties.autoplay,
                muted: this.videoProperties.muted,
                language: 'de',
                preload: 'auto',
                fluid: true,
                aspectRatio: '2:1',
                //autoplay: true,
                // inactivityTimeout: 1,
                html5: {
                    hls: {
                        overrideNative: true,
                        limitRenditionByPlayerDimensions: true,
                        useDevicePixelRatio: true,
                        bandwidth: 16777216
                    },
                    nativeAudioTracks: false,
                    nativeVideoTracks: false,
                    useBandwidthFromLocalStorage: true
                }
            };
            this.player = videojs(this.$refs.player, options);
            //this.player.httpSourceSelector();

            // this.player.controls(false)

            this.player.on('ended', () => {
                this.player.posterImage.show();
                // vid.bigPlayButton.show();
                this.player.currentTime(0);
            });

            this.player.on('touchstart', event => {
                // this.$refs.player.parentNode.classList.add('vjs-show-controls');
                if (event.target.nodeName === 'VIDEO') {
                    if (this.player.paused()) this.player.play();
                    else this.player.pause();
                }
            });

            videojs.log.level('error');
        }
    },
    mounted() {
        this.initialise();
    },
    beforeDestroy() {
        if (this.player) this.player.dispose();
    }
};
</script>
<style lang="sass" scoped>
    @import "~@/assets/sass/variables"
    ::v-deep 
        .vjs-poster
            @apply bg-cover
        .video-js.video-js .vjs-big-play-button
            @apply transition ease-in-out duration-300 rounded-full w-16 h-16
            line-height: 4rem
            color: $color-base-text
            border: 2px solid gray
            background: rgba(gray, 0.8)
            &:hover
               background-color: rgba(#FFF, 0.8)
            .vjs-icon-placeholder:before
                @apply text-4xl
</style>
